import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * 金額／交易／KYC 等操作需登入；一般瀏覽（搜尋、行情）不需登入。
 */
export default function useRequireAuth() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback(
    (targetPath, { replace = false } = {}) => {
      if (!targetPath) {
        return false;
      }
      if (isAuthenticated) {
        navigate(targetPath, { replace });
        return true;
      }
      navigate('/login', {
        replace,
        state: { from: { pathname: targetPath, search: location.search } },
      });
      return false;
    },
    [isAuthenticated, navigate, location.search]
  );
}
